import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Row, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import PriceFormat from "components/PriceFormat";
import Bundle from "components/Bundle";

const CartItem = props => {
  const {
    sku,
    productName,
    author,
    retailPrice,
    unitPrice,
    courseBundleCount,
    omsSavedcartLineItemId,
    onCartRemove,
    showRemove
  } = props;

  const [removed, setRemoved] = useState(false);
  return (
    <div className={`cart__item ${removed ? " is-removed" : ""}`} key={sku}>
      <div className="cart__item-container">
        <Row>
          <Col>
            <div className="cart__item-name">{productName}</div>
            {author && <div className="cart__item-author">{author}</div>}
            {unitPrice !== retailPrice && (
              <div className="cart__item-price">
                <FontAwesomeIcon icon={faTag} className="me-2" />
                <span>
                  <PriceFormat value={retailPrice} />
                </span>
                <span>
                  <PriceFormat value={unitPrice} />
                </span>
              </div>
            )}
            {unitPrice === 0 && (
              <div className="cart__item-price cart__item-price--free">
                <FontAwesomeIcon icon={faTag} className="me-2" />
                <span>Free</span>
              </div>
            )}
            {courseBundleCount !== null && (
              <div className="cart__item-type">
                <Bundle bundleCount={courseBundleCount} />
              </div>
            )}
          </Col>
          <Col>
            {showRemove && (
              <div className="cart__item-remove">
                {removed ? (
                  <Button color="link" size="sm" disabled>
                    <FontAwesomeIcon icon={faTrashAlt} className="me-2" />
                    <span>Removing</span>
                  </Button>
                ) : (
                  <Button
                    className="cartItemRemove"
                    color="link"
                    size="sm"
                    onClick={() => {
                      onCartRemove(omsSavedcartLineItemId);
                      setRemoved(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} className="me-2" />
                    <span>Remove</span>
                  </Button>
                )}
              </div>
            )}
            <div className="cart__item-total">
              <div>Item Total</div>
              <PriceFormat value={unitPrice} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

CartItem.propTypes = {
  sku: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  author: PropTypes.string,
  retailPrice: PropTypes.number,
  unitPrice: PropTypes.number.isRequired,
  courseBundleCount: PropTypes.number,
  omsSavedcartLineItemId: PropTypes.number,
  onCartRemove: PropTypes.func.isRequired,
  showRemove: PropTypes.bool
};

CartItem.defaultProps = {
  author: null,
  courseBundleCount: null,
  showRemove: true,
  omsSavedcartLineItemId: undefined,
  retailPrice: undefined
};

export default CartItem;
